module.exports = __webpack_public_path__ + "static/media/Поцейко П., Ровба Е..2bb96b5e.pdf";